/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeclarationScheduleResponseDto
 */
export interface DeclarationScheduleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DeclarationScheduleResponseDto
     */
    declarationId: number;
    /**
     * 
     * @type {string}
     * @memberof DeclarationScheduleResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof DeclarationScheduleResponseDto
     */
    declarationName: string;
    /**
     * 
     * @type {string}
     * @memberof DeclarationScheduleResponseDto
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof DeclarationScheduleResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof DeclarationScheduleResponseDto
     */
    programOrder: string;
    /**
     * 
     * @type {string}
     * @memberof DeclarationScheduleResponseDto
     */
    programOrderTotalPremium: string;
    /**
     * 
     * @type {Date}
     * @memberof DeclarationScheduleResponseDto
     */
    dueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DeclarationScheduleResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DeclarationScheduleResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the DeclarationScheduleResponseDto interface.
 */
export function instanceOfDeclarationScheduleResponseDto(value: object): value is DeclarationScheduleResponseDto {
    if (!('declarationId' in value) || value['declarationId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('declarationName' in value) || value['declarationName'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('programOrder' in value) || value['programOrder'] === undefined) return false;
    if (!('programOrderTotalPremium' in value) || value['programOrderTotalPremium'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DeclarationScheduleResponseDtoFromJSON(json: any): DeclarationScheduleResponseDto {
    return DeclarationScheduleResponseDtoFromJSONTyped(json, false);
}

export function DeclarationScheduleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeclarationScheduleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'declarationId': json['declarationId'],
        'contractId': json['contractId'],
        'declarationName': json['declarationName'],
        'entityName': json['entityName'],
        'country': json['country'],
        'programOrder': json['programOrder'],
        'programOrderTotalPremium': json['programOrderTotalPremium'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function DeclarationScheduleResponseDtoToJSON(json: any): DeclarationScheduleResponseDto {
    return DeclarationScheduleResponseDtoToJSONTyped(json, false);
}

export function DeclarationScheduleResponseDtoToJSONTyped(value?: DeclarationScheduleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'declarationId': value['declarationId'],
        'contractId': value['contractId'],
        'declarationName': value['declarationName'],
        'entityName': value['entityName'],
        'country': value['country'],
        'programOrder': value['programOrder'],
        'programOrderTotalPremium': value['programOrderTotalPremium'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

